export default __webpack_public_path__ + "static/media/scan.9db691be.png";